<template>
  <div class="page">
    <!-- 搜索栏头部 -->
    <div class="header-bar">
      <van-icon name="arrow-left" class="header-img" @click="back"></van-icon>
      <van-search class="header-search"  background="#117281" v-model="searchKeyword"
        @search="viewItemList">
      </van-search>
      <van-button type="primary" @click="viewItemList">搜索</van-button>
    </div>
    <!-- 内容 -->
    <div class="history">
      <router-view ref="result"></router-view>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  components: {},
  data () {
    return {
      searchKeyword: ''
    }
  },
  created () {
    this.searchKeyword = this.keyword
  },
  computed: {
    ...mapState({
      keyword: state => state.search.keyword
    })
  },
  methods: {
    viewItemList () {
      if (this.searchKeyword.trim()) {
        // 历史搜索
        this.$store.dispatch('search_a_getHistoryListData').then(res => {
          let historyList = res
          if (!historyList.includes(this.searchKeyword.trim())) {
            historyList.push(this.searchKeyword.trim())
            this.$store.commit('search_m_setHistoryListData', historyList)
          }
        })
        // 调用子路由查询方法
        if (this.$route.fullPath !== '/search/searchResult') {
          this.$router.push({ path: '/search/searchResult' })
        }
        if (this.$refs.result.queryItemList) {
          this.$nextTick(() => { this.$refs.result.queryItemList() })
        }
        this.$store.commit('search_m_setKeywordData', this.searchKeyword.trim())
        this.$store.commit('search_m_setResultListData', [])
      }
    },
    // tag搜索
    setSearchKey (value) {
      this.searchKeyword = value
      this.viewItemList()
    },
    back () {
      this.searchKeyword = ''
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped lang="less">
.header-bar {
  display: flex;
  background-color: #117281;
  align-items: center;
  padding-left: 0.35rem;
  width: 100%;
  box-sizing: border-box;
  z-index: 9;
  position: fixed;
  top: 0px;
  left: 0px;

  .header-search {
    flex: 1;
    height: 1.25rem;
  }

  .header-img {
    width: 0.85rem;
    height: 0.85rem;
    line-height: 0.85rem;
    color: #fff;
  }

  .header-qr-icon {
    width: 0.85rem;
    height: 0.85rem;
    line-height: 0.85rem;
    color: #fff;
  }
}

.history {
  padding: 0.35rem;
  height: 100%;
}
</style>
